import { createSlice } from "@reduxjs/toolkit";
import { fetchBookletDetail, bookBookletSlots, fetchMerchantCamBookings } from "./bookletThunks";

const initialState = {
  booklet: null,
  pages: [],
  bookings: [],
  loading: false,
  error: null,
  bookingSuccess: null,
  myBookings: [],
  myBookingsLoading: false,
  myBookingsError: null,
};

const bookletSlice = createSlice({
  name: "booklet",
  initialState,
  reducers: {
    clearBooklet: (state) => {
    state.booklet = null;
    state.pages = [];
    state.bookings = [];
    state.loading = false;
    state.error = null;
  }
  },
  extraReducers: (builder) => {
    builder

      // ---------------- FETCH BOOKLET ----------------
      .addCase(fetchBookletDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.booklet = null;       
      })
      .addCase(fetchBookletDetail.fulfilled, (state, action) => {
        state.loading = false;
          if (!action.payload?.booklet) {
          // 🟢 If API returns success false or no booklet
          state.booklet = null;
          state.pages = [];
          state.bookings = [];
          return;
        }
        state.booklet = action.payload.booklet;
        state.pages = action.payload.pages;
        state.bookings = action.payload.bookings;
      })
      .addCase(fetchBookletDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to load booklet";
      })

      // ---------------- BOOK SLOTS ----------------
      .addCase(bookBookletSlots.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bookBookletSlots.fulfilled, (state, action) => {
        state.loading = false;
        state.bookingSuccess = action.payload;
      })
      .addCase(bookBookletSlots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Booking failed";
      })

      // ---------------- MERCHANT CAM BOOKINGS ----------------
      .addCase(fetchMerchantCamBookings.pending, (state) => {
        state.myBookingsLoading = true;
        state.myBookingsError = null;
      })
      .addCase(fetchMerchantCamBookings.fulfilled, (state, action) => {
        state.myBookingsLoading = false;
        state.myBookings = action.payload || [];
      })
      .addCase(fetchMerchantCamBookings.rejected, (state, action) => {
        state.myBookingsLoading = false;
        state.myBookingsError = action.payload?.message || "Failed to load CAM bookings";
      });
  }
});

export const { clearBooklet  } = bookletSlice.actions;
export default bookletSlice.reducer;
